import { Component, OnInit } from '@angular/core';
import { appService } from '../../../app/_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
declare var $: any;

@Component({
    selector: 'app-booking-dashboard',
    templateUrl: './booking-dashboard.component.html'
})
export class BookingDashboardComponent implements OnInit {
    static that: BookingDashboardComponent;

    SelectedComapnyName: any;
    SelectedCompanyAdd: any;
    SelectedCompanyCIN: any;
    SelectedCompantGSTIN: any;
    SelectedCompanyLogo: any;

    BookingStages: any = [];
    TruckHireChallanData: any = {};

    BookingDetail: any = {};
    ConsignmentDetail: any = [];
    SalesDetail: any = [];
    BillsDetail: any = [];

    InvoiceAmount: any = 0;
    InvoiceBalanceDue: any = 0;

    BillAmount: any = 0;
    BillBalanceDue: any = 0;
    svg: any;

    constructor(
        private _appService: appService,
        private toastr: ToastrService,
    ) {
        BookingDashboardComponent.that = this;
    }

    ngOnInit() {
        this.SelectedComapnyName = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedComapnyName;
        this.SelectedCompanyAdd = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompanyAdd;
        this.SelectedCompanyCIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompanyCIN;
        this.SelectedCompantGSTIN = JSON.parse(localStorage.getItem('ChnageCompnayId')).SelectedCompantGSTIN;
        this.SelectedCompanyLogo = JSON.parse(localStorage.getItem('ChnageCompnayId')).CompanyLogoPath;
        $("#BookingDashboardLogo").attr("src", environment.apiUrl + this.SelectedCompanyLogo);

    }


    ClearData() {
        this.TruckHireChallanData = {};
        this.BookingDetail = {};
        this.ConsignmentDetail = [];
        this.SalesDetail = [];
        this.BillsDetail = [];

        this.InvoiceAmount = 0;
        this.InvoiceBalanceDue = 0;
        this.BillAmount = 0;
        this.BillBalanceDue = 0;
    }
    //-----------------------------Calculations------------------------------
    CalculateTotal() {

        var TotalWeight: any = 0
        var TotalVolume: any = 0;
        var Margin: any = 0;
        this.ConsignmentDetail.forEach(element => {
            TotalWeight = TotalWeight + element.Weight;
            TotalVolume = TotalVolume + element.Volume;
        });

        this.SalesDetail.forEach(element => {
            this.InvoiceAmount = this.InvoiceAmount + element.TotalAmount;
            this.InvoiceBalanceDue = this.InvoiceBalanceDue + element.BalanceDue;
            if (element.DateDifference < 0)
                element.DateDifference *= (-1);

        });
        this.InvoiceAmount = parseFloat(this.InvoiceAmount).toFixed(2);

        this.BillsDetail.forEach(element => {
            this.BillAmount = this.BillAmount + element.Amount;
            this.BillBalanceDue = this.BillBalanceDue + element.BalanceDue;
            if (element.DateDifference < 0)
                element.DateDifference *= (-1);
        });
        this.BillAmount = parseFloat(this.BillAmount).toFixed(2);

        if (this.BillAmount > this.InvoiceAmount) {
            $(".PLColor").css("color", "red");
        }
        else {
            $(".PLColor").css("color", "green");
        }
        //---------------------Margin---------------------------
        Margin = parseFloat((this.InvoiceAmount - this.BillAmount).toFixed(2));
        var TotalMarginPer: any = parseFloat(((Margin * 100) / this.InvoiceAmount).toFixed(2));
        this.BookingDetail.TotalMargin = Margin;
        TotalMarginPer = parseFloat(TotalMarginPer || 0);
        if (TotalMarginPer < 0) {
            document.getElementById('progressProfitSummary').style.width = 0 + "%";
            this.BookingDetail.TotalMarginPer = 0;
        }
        else if (TotalMarginPer > 100) {
            document.getElementById('progressProfitSummary').style.width = 100 + "%";
            this.BookingDetail.TotalMarginPer = 100;
        }
        else {
            document.getElementById('progressProfitSummary').style.width = TotalMarginPer + "%";
            this.BookingDetail.TotalMarginPer = TotalMarginPer;
        }
        //---------------------Weight---------------------------
        var ProgressWeight: any = ((parseFloat(TotalWeight || 0) * 100) / parseInt(this.BookingDetail.VehicleCapacity || 1)).toFixed(2);
        this.BookingDetail.TotalWeight = TotalWeight;
        ProgressWeight = parseFloat(ProgressWeight || 0);

        if (ProgressWeight < 0) {
            document.getElementById('progressWeightSummary').style.width = 0 + "%";
            this.BookingDetail.TotalWeightPer = 0;
        }
        else if (ProgressWeight > 100) {
            document.getElementById('progressWeightSummary').style.width = 100 + "%";
            this.BookingDetail.TotalWeightPer = 100;
        }
        else {
            document.getElementById('progressWeightSummary').style.width = ProgressWeight + "%";
            this.BookingDetail.TotalWeightPer = ProgressWeight;
        }
        //---------------------Volume---------------------------
        var ProgressVolume: any = ((parseFloat(TotalWeight || 0) * 100) / parseInt(this.BookingDetail.VehicleVolume || 1)).toFixed(2);
        this.BookingDetail.TotalVolume = TotalVolume;
        ProgressVolume = parseFloat(ProgressVolume || 0);

        if (ProgressVolume < 0) {
            document.getElementById('progressVolumeSummary').style.width = 0 + "%";
            this.BookingDetail.TotalVolumePer = 0;
        }
        else if (ProgressVolume > 100) {
            document.getElementById('progressVolumeSummary').style.width = 100 + "%";
            this.BookingDetail.TotalVolumePer = 100;
        }
        else {
            document.getElementById('progressVolumeSummary').style.width = ProgressVolume + "%";
            this.BookingDetail.TotalVolumePer = ProgressVolume;
        }

    }
    //--------------------------------Print THC------------------------------------

    PrintTHC() {
        this.TruckHireChallanData.TotalCharge = 0;
        this.TruckHireChallanData.TotalWeight = 0;
        this.TruckHireChallanData.TotalQty = 0;
        this.TruckHireChallanData.TotalValue = 0;
        this.TruckHireChallanData.ConsignmentDetailList.forEach(element => {
            var TotalQty = 0;
            var TotalWeight = 0;
            var TotalValue = 0;

            element.ProductDetail.forEach(element => {
                TotalQty = TotalQty + element.Quantity;
                TotalWeight = TotalWeight + element.GrossWeight;
                TotalValue = TotalValue + element.Value;
            });

            element.TotalQty = TotalQty;
            element.TotalWeight = parseFloat(TotalWeight.toFixed(2));
            element.TotalValue = TotalValue;

            this.TruckHireChallanData.TotalWeight += element.TotalWeight;
            this.TruckHireChallanData.TotalQty += element.TotalQty;
            this.TruckHireChallanData.TotalValue += element.TotalValue
        });
        this.TruckHireChallanData.TotalWeight = parseFloat(this.TruckHireChallanData.TotalWeight.toFixed(2))
        let i = 0;
        setTimeout(() => {
            this.TruckHireChallanData.ConsignmentDetailList.forEach(element => {
                if (element.IsDoorDelivery == true) {
                    $("#PrintDoorDeliverySummary_" + i).attr('checked', true);
                }
                else {
                    $("#PrintDoorDeliverySummary_" + i).attr('checked', false);
                }
                if (element.IsUnloadedByParty == true) {
                    $("#PrintUnloadedByPartySummary_" + i).attr('checked', true);
                }
                else {
                    $("#PrintUnloadedByPartySummary_" + i).attr('checked', false);
                }
                i++;
            });
        }, 200);

        setTimeout(() => {
            var divElements = document.getElementById('PrintModalTHCSummary');
            var $iframe = $("<iframe>").appendTo("body");
            var printDiv = "<html><head><title> Truck Hire Challan </title></head><body>" + divElements.innerHTML + "</body></html>";
            $iframe.contents().find('body').html(printDiv);
            var win = $iframe[0].contentWindow || $iframe[0];
            $(win.document).ready(function () {
                setTimeout(() => {
                    win.window.print();
                    setTimeout(() => {
                        $iframe.remove();
                    }, 500);
                })
            })
            $iframe.contents().find('body').html(printDiv);
        }, 500);

        this.UpdateTHCPrintedCount(this.TruckHireChallanData.THCId);
    }

    UpdateTHCPrintedCount(THCId) {
        this._appService.GetById("BookingOrigin", "UpdateTHCCount", THCId).subscribe(response => {
        }, err => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
        });
    }
}
